// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { sparkleSwirls16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-sparkle-swirls': IconSparkleSwirls;
    }
}

/**
 * The icon component for the 'sparkleSwirls' icon
 */
export class IconSparkleSwirls extends IconSvg {
    public constructor() {
        super(sparkleSwirls16X16);
    }
}

registerIconSvg('icon-sparkle-swirls', IconSparkleSwirls);
export const iconSparkleSwirlsTag = 'nimble-icon-sparkle-swirls';
